import React from "react";

export default function UserSortableButtonWidget(props) {
  if (props.editable) return <i className="fa fa-bars" />;
}
